module.exports = __webpack_public_path__ + "static/img/donation.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopping/donation.jpg
// module id = 43+T
// module chunks = 0